module.exports = __webpack_public_path__ + "img/DFW_DemonStaff.7bb37005.png";